import React from 'react';
import PropTypes from 'prop-types';
import { Pencil } from '../Icons';

const GiftMessage = ({ savedGiftData, doEditGift, purchaseSuccess }) => (
  <div className="gift-message-container">
    <div className="gift-message-user__details">
      <div className="gift-message-email">
        <span>To:</span>
        <p>{savedGiftData.recipientName}</p>
        <p>{savedGiftData.recipientEmail}</p>
      </div>
      <div className="gift-message-email">
        <span>From:</span>
        <p>{savedGiftData.purchaserName}</p>
        <p>{savedGiftData.purchaserEmail}</p>
      </div>
    </div>
    {
      savedGiftData.message.length ?
        <div className="gift-message">
          <span>Message:</span>
          <div>{savedGiftData.message}</div>
        </div>
        : null
    }
    {
      purchaseSuccess ?
        null
        :
        <div className="gift-message-edit" onClick={doEditGift} onKeyPress={doEditGift}>
          <Pencil /><label>EDIT</label>
        </div>
    }
  </div>
);

GiftMessage.propTypes = {
  savedGiftData: PropTypes.shape({}).isRequired,
  doEditGift: PropTypes.func.isRequired,
  purchaseSuccess: PropTypes.bool
};

GiftMessage.defaultProps = {
  purchaseSuccess: false
};

export default GiftMessage;
